import React from "react";

/** Resting height of each bar, as a fraction of the full height. */
const BAR_BASE = [0.35, 0.6, 0.45, 0.8, 0.4];

interface VoiceLevelBarsProps {
  /** Microphone loudness, 0..1. */
  level: number;
}

const VoiceLevelBars: React.FC<VoiceLevelBarsProps> = ({ level }) => (
  <span className="llm-chat-voice-bars" aria-hidden="true">
    {BAR_BASE.map((base, index) => (
      <span
        key={index}
        className="llm-chat-voice-bar"
        style={{ transform: `scaleY(${Math.min(1, base * 0.5 + level)})` }}
      />
    ))}
  </span>
);

export default VoiceLevelBars;
